import { h } from "preact";
import { Category } from "../services/data";
import { getCategoryUrl } from "../services/navigation";
import "./categories.scss";

export function Categories(props: { categories: Category[], categoryId: string }) {
    return (
        <div class="categories-grid">
            {
                props.categories.map(cat => <a href={getCategoryUrl(cat)} class={"linkbutton" + (cat.id == props.categoryId ? " active" : "")}>{cat.title}</a>)
            }
        </div>
    );
}
